module.exports = __webpack_public_path__ + "static/img/group.b0f0b32d.svg";